import PaintPaletteIcon from '@atlaskit/icon/core/paint-palette';
import * as React from 'react';

export function SvgPalette() {
  return <PaintPaletteIcon label="" testId="ads-refreshed-icon" />;
}
